// Diamond overlay size per carat pill: explicit px width/height per carat weight, per shape.
const CARAT_SIZES_BY_SHAPE = {
  round: {
    // '1.0': { width: 33.65, height: 33.66 },
    // '1.5': { width: 38.52, height: 38.53 },
    '1.0': { width: 53.12, height: 53.12 },
    '1.5': { width: 57.31, height: 57.31 },
    '2.0': { width: 60.49, height: 60.49 },
    '2.5': { width: 63.68, height: 63.68 },
    '3.0': { width: 66.8, height: 66.68 },
    '3.5': { width: 69.68, height: 69.68 },
    '4.0': { width: 73.68, height: 73.68 },
    '4.5': { width: 80.68, height: 80.68 },
    '5.0': { width: 86.68, height: 86.68 },
  },
  marquise: {
    '1.0': { width: 53.49, height: 53.49 },
    '1.5': { width: 57.90, height: 57.90 },
    '2.0': { width: 62.39, height: 62.39 },
    '2.5': { width: 66.80, height: 66.80 },
    '3.0': { width: 71.29, height: 71.29 },
    '3.5': { width: 75.70, height: 75.70 },
    '4.0': { width: 80.19, height: 80.19 },
    '4.5': { width: 85.70, height: 85.70 },
    '5.0': { width: 90.19, height: 90.19 },    
  },
  radiant: {
    '1.0': { width: 43.90, height: 43.90 },
    '1.5': { width: 48.34, height: 48.34 },
    '2.0': { width: 52.08, height: 52.08 },
    '2.5': { width: 56.57, height: 56.57 },
    '3.0': { width: 60.77, height: 60.77 },
    '3.5': { width: 64.79, height: 64.79 },
    '4.0': { width: 68.25, height: 68.25 },
    '4.5': { width: 72, height: 72 },
    '5.0': { width: 76, height: 76 }
  },
  emerald: {
     '1.0': { width: 43.90, height: 43.90 },
    '1.5': { width: 48.34, height: 48.34 },
    '2.0': { width: 52.08, height: 52.08 },
    '2.5': { width: 56.57, height: 56.57 },
    '3.0': { width: 60.77, height: 60.77 },
    '3.5': { width: 64.79, height: 64.79 },
    '4.0': { width: 68.25, height: 68.25 },
    '4.5': { width: 72, height: 72 },
    '5.0': { width: 76, height: 76 }
  },
  'elongated cushion': {
    '1.0': { width: 43.90, height: 43.90 },
    '1.5': { width: 48.34, height: 48.34 },
    '2.0': { width: 52.08, height: 52.08 },
    '2.5': { width: 56.57, height: 56.57 },
    '3.0': { width: 60.77, height: 60.77 },
    '3.5': { width: 64.79, height: 64.79 },
    '4.0': { width: 68.25, height: 68.25 },
    '4.5': { width: 72, height: 72 },
    '5.0': { width: 76, height: 76 }
  },
  oval: {
    //  '1.0': { width: 40.90, height: 40.90 },
    '1.0': { width: 46.34, height: 46.34 },
    '1.5': { width: 50.08, height: 50.08 },
    '2.0': { width: 54.57, height: 54.57 },
    '2.5': { width: 58.77, height: 58.77 },
    '3.0': { width: 62.79, height: 62.79 },
    '3.5': { width: 66.25, height: 66.25 },
    '4.0': { width: 70, height: 70 },
    '4.5': { width: 74, height: 74 },
    '5.0': { width: 78, height: 78 }
  },
  pear: {
    '1.0': { width: 38.65, height: 38.65 },
    '1.5': { width: 44.31, height: 44.31 },
    '2.0': { width: 48.72, height: 48.72 },
    '2.5': { width: 52.67, height: 52.67 },
    '3.0': { width: 55.76, height: 55.76 },
    '3.5': { width: 58.60, height: 58.60 },
    '4.0': { width: 61.43, height: 61.43 },
    '4.5': { width: 63.66, height: 63.66 },
    '5.0': { width: 65.84, height: 65.84 },
  },
  princess: {
    // '1.0': { width: 38.21, height: 38.21 },
    // '1.5': { width: 41.39, height: 41.39 },
    // '1.0': { width: 44.57, height: 44.57 },
    '1.0': { width: 47.76, height: 47.76 },
    '1.5': { width: 50.94, height: 50.94 },
    '2.0': { width: 54.12, height: 54.12 },
    '2.5': { width: 57.31, height: 57.31 },
    '3.0': { width: 60.49, height: 60.49 },
    '3.5': { width: 63.68, height: 63.68 },
    '4.0': { width: 66.8, height: 66.68 },
    '4.5': { width: 69.68, height: 69.68 },
    '5.0': { width: 73.68, height: 73.68 },
  },
  asscher: {
    '1.0': { width: 47.76, height: 47.76 },
    '1.5': { width: 50.94, height: 50.94 },
    '2.0': { width: 54.12, height: 54.12 },
    '2.5': { width: 57.31, height: 57.31 },
    '3.0': { width: 60.49, height: 60.49 },
    '3.5': { width: 63.68, height: 63.68 },
    '4.0': { width: 66.8, height: 66.68 },
    '4.5': { width: 69.68, height: 69.68 },
    '5.0': { width: 73.68, height: 73.68 },
  },
  cushion: {
    '1.0': { width: 47.76, height: 47.76 },
    '1.5': { width: 50.94, height: 50.94 },
    '2.0': { width: 54.12, height: 54.12 },
    '2.5': { width: 57.31, height: 57.31 },
    '3.0': { width: 60.49, height: 60.49 },
    '3.5': { width: 63.68, height: 63.68 },
    '4.0': { width: 66.8, height: 66.68 },
    '4.5': { width: 69.68, height: 69.68 },
    '5.0': { width: 73.68, height: 73.68 },
  },
};

// Diamond overlay size per carat pill on tablet (750px-1024px), per shape.
const CARAT_SIZES_TABLET_BY_SHAPE = {
  round: {
    '1.0': { width: 80.68, height: 80.68 },
    '1.5': { width: 86.68, height: 86.68 },
    '2.0': { width: 92.12, height: 92.12 },
    '2.5': { width: 98.31, height: 98.31 },
    '3.0': { width: 105.49, height: 105.49 },
    '3.5': { width: 112.68, height: 112.68 },
    '4.0': { width: 118.8, height: 118.68 },
    '4.5': { width: 125.68, height: 125.68 },
    '5.0': { width: 132.68, height: 132.68 },
  },
     marquise: {
    '1.0': { width: 70.58, height: 70.58 },
    '1.5': { width: 75.99, height: 75.99 },
    '2.0': { width: 80.49, height: 80.49 },
    '2.5': { width: 85.90, height: 85.90 },
    '3.0': { width: 92.39, height: 92.39 },
    '3.5': { width: 99.80, height: 99.80 },
    '4.0': { width: 107.29, height: 107.29 },
    '4.5': { width: 115.70, height: 115.70 },
    '5.0': { width: 120.19, height: 120.19 },
   },
   radiant: {
    '1.0': { width: 70.58, height: 70.58 },
    '1.5': { width: 75.99, height: 75.99 },
    '2.0': { width: 80.49, height: 80.49 },
    '2.5': { width: 85.90, height: 85.90 },
    '3.0': { width: 90.39, height: 90.39 },
    '3.5': { width: 95.80, height: 95.80 },
    '4.0': { width: 100.29, height: 100.29 },
    '4.5': { width: 105.70, height: 105.70 },
    '5.0': { width: 110.19, height: 110.19 },
   },
   emerald: {
    '1.0': { width: 70.58, height: 70.58 },
    '1.5': { width: 75.99, height: 75.99 },
    '2.0': { width: 80.49, height: 80.49 },
    '2.5': { width: 85.90, height: 85.90 },
    '3.0': { width: 90.39, height: 90.39 },
    '3.5': { width: 95.80, height: 95.80 },
    '4.0': { width: 100.29, height: 100.29 },
    '4.5': { width: 105.70, height: 105.70 },
    '5.0': { width: 110.19, height: 110.19 },
   },
  'elongated cushion': {
    '1.0': { width: 70.58, height: 70.58 },
    '1.5': { width: 75.99, height: 75.99 },
    '2.0': { width: 80.49, height: 80.49 },
    '2.5': { width: 85.90, height: 85.90 },
    '3.0': { width: 90.39, height: 90.39 },
    '3.5': { width: 95.80, height: 95.80 },
    '4.0': { width: 100.29, height: 100.29 },
    '4.5': { width: 105.70, height: 105.70 },
    '5.0': { width: 110.19, height: 110.19 },
   },
  // oval: {
  //   //  '1.0': { width: 40.90, height: 40.90 },
  //   '1.0': { width: 43.34, height: 43.34 },
  //   '1.5': { width: 46.08, height: 46.08 },
  //   '2.0': { width: 48.57, height: 48.57 },
  //   '2.5': { width: 50.77, height: 50.77 },
  //   '3.0': { width: 52.79, height: 52.79 },
  //   '3.5': { width: 59.25, height: 59.25 },
  //   '4.0': { width: 65, height: 65 },
  //   '4.5': { width: 72, height: 72 },
  //   '5.0': { width: 78, height: 78 }
  // },
  // pear: {
  //   '1.0': { width: 38.65, height: 38.65 },
  //   '1.5': { width: 44.31, height: 44.31 },
  //   '2.0': { width: 48.72, height: 48.72 },
  //   '2.5': { width: 52.67, height: 52.67 },
  //   '3.0': { width: 55.76, height: 55.76 },
  //   '3.5': { width: 58.60, height: 58.60 },
  //   '4.0': { width: 61.43, height: 61.43 },
  //   '4.5': { width: 63.66, height: 63.66 },
  //   '5.0': { width: 65.84, height: 65.84 },
  // },
   princess: {
    '1.0': { width: 75.68, height: 75.68 },
    '1.5': { width: 80.68, height: 80.68 },
    '2.0': { width: 85.12, height: 85.12 },
    '2.5': { width: 90.31, height: 90.31 },
    '3.0': { width: 95.49, height: 95.49 },
    '3.5': { width: 102.68, height: 102.68 },
    '4.0': { width: 109.8, height: 109.68 },
    '4.5': { width: 116.68, height: 116.68 },
    '5.0': { width: 122.68, height: 122.68 },
   },
  asscher: {
    '1.0': { width: 75.68, height: 75.68 },
    '1.5': { width: 80.68, height: 80.68 },
    '2.0': { width: 85.12, height: 85.12 },
    '2.5': { width: 90.31, height: 90.31 },
    '3.0': { width: 95.49, height: 95.49 },
    '3.5': { width: 102.68, height: 102.68 },
    '4.0': { width: 109.8, height: 109.68 },
    '4.5': { width: 116.68, height: 116.68 },
    '5.0': { width: 122.68, height: 122.68 },
   },
   cushion: {
    '1.0': { width: 75.68, height: 75.68 },
    '1.5': { width: 80.68, height: 80.68 },
    '2.0': { width: 85.12, height: 85.12 },
    '2.5': { width: 90.31, height: 90.31 },
    '3.0': { width: 95.49, height: 95.49 },
    '3.5': { width: 102.68, height: 102.68 },
    '4.0': { width: 109.8, height: 109.68 },
    '4.5': { width: 118.68, height: 118.68 },
    '5.0': { width: 127.68, height: 127.68 },
   },
 
};

// Diamond overlay size per carat pill on mobile (max-width: 749px), per shape.
const CARAT_SIZES_MOBILE_BY_SHAPE = {
   round: {
    '1.0': { width: 41.53, height: 41.53 },
    '1.5': { width: 45.63, height: 45.63 },
    '2.0': { width: 49.82, height: 49.82 },
    '2.5': { width: 53.92, height: 53.92 },
    '3.0': { width: 58.11, height: 58.11 },
    '4.0': { width: 66.40, height: 66.40 },
    '5.0': { width: 71.69, height: 71.69 },
  },
  marquise: {
    '1.0': { width: 41.53, height: 41.53 },
    '1.5': { width: 45.63, height: 45.63 },
    '2.0': { width: 49.82, height: 49.82 },
    '2.5': { width: 53.92, height: 53.92 },
    '3.0': { width: 58.11, height: 58.11 },
    '4.0': { width: 66.40, height: 66.40 },
    '5.0': { width: 74.69, height: 74.69 },
  },
  emerald: {
    '1.0': { width: 34.61, height: 34.61 },
    '1.5': { width: 38.10, height: 38.10 },
    '2.0': { width: 40.37, height: 40.37 },
    '2.5': { width: 42.92, height: 42.92 },
    '3.0': { width: 47.29, height: 47.29 },
    '4.0': { width: 53.38, height: 53.38 },
    '5.0': { width: 59, height: 59 },
  },
  radiant: {
    // '1.0': { width: 29.79, height: 29.79 },
    '1.0': { width: 34.61, height: 34.61 },
    '1.5': { width: 38.10, height: 38.10 },
    '2.0': { width: 40.37, height: 40.37 },
    '2.5': { width: 42.92, height: 42.92 },
    '3.0': { width: 47.29, height: 47.29 },
    '4.0': { width: 53.38, height: 53.38 },
    '5.0': { width: 59, height: 59 }
  },
  'elongated cushion': {
    '1.0': { width: 34.61, height: 34.61 },
    '1.5': { width: 38.10, height: 38.10 },
    '2.0': { width: 40.37, height: 40.37 },
    '2.5': { width: 42.92, height: 42.92 },
    '3.0': { width: 47.29, height: 47.29 },
    '4.0': { width: 55.38, height: 55.38 },
    '5.0': { width: 62, height: 62 }
  },
  oval: {
    // '1.0': { width: 34.61, height: 34.61 },
    '1.0': { width: 38.10, height: 38.10 },
    '1.5': { width: 40.37, height: 40.37 },
    '2.0': { width: 42.92, height: 42.92 },
    '2.5': { width: 47.29, height: 47.29 },
    '3.0': { width: 53.38, height: 53.38 },
    '4.0': { width: 60, height: 60 },
    '5.0': { width: 67, height: 67 }

  },
  pear: {
    // '1.0': { width: 25.18, height: 25.18 },
    // '1.5': { width: 28.86, height: 28.86 },
    '1.0': { width: 31.74, height: 31.74 },
    '1.5': { width: 34.31, height: 34.31 },
    '2.0': { width: 36.33, height: 36.33 },
    '2.5': { width: 40.10, height: 40.10 },
    '3.0': { width: 42.89, height: 42.89 },
    '4.0': { width: 47.89, height: 47.89 },
    '5.0': { width: 53.00, height: 53.00 },
  },
  princess: {
    // '1.0': { width: 24.59, height: 24.59 },
    // '1.5': { width: 26.96, height: 26.96 },
    // '1.0': { width: 29.03, height: 29.03 },
    '1.0': { width: 31.11, height: 31.11 },
    '1.5': { width: 33.18, height: 33.18 },
    '2.0': { width: 37.33, height: 37.33 },
    '2.5': { width: 41.48, height: 41.48 },
    '3.0': { width: 45.48, height: 45.48 },
    '4.0': { width: 49.48, height: 49.48 },
    '5.0': { width: 55.48, height: 55.48 },

  },
  asscher: {
    '1.0': { width: 33.11, height: 33.11 },
    '1.5': { width: 37.18, height: 37.18 },
    '2.0': { width: 41.33, height: 41.33 },
    '2.5': { width: 45.48, height: 45.48 },
    '3.0': { width: 49.48, height: 49.48 },
    '4.0': { width: 55.48, height: 55.48 },
    '5.0': { width: 60.48, height: 60.48 },
  },
  cushion: {
    '1.0': { width: 35.11, height: 35.11 },
    '1.5': { width: 39.18, height: 39.18 },
    '2.0': { width: 43.33, height: 43.33 },
    '2.5': { width: 47.48, height: 47.48 },
    '3.0': { width: 51.48, height: 51.48 },
    '4.0': { width: 57.48, height: 57.48 },
    '5.0': { width: 65.48, height: 65.48 },
  },
};

class DiamondSizeGuide extends HTMLElement {
  connectedCallback() {
    this.diamond = this.querySelector('[data-diamond-size-guide-diamond]');
    this.pills = Array.from(this.querySelectorAll('[data-diamond-size-guide-pill]'));
    this.shownWithValue = this.querySelector('[data-diamond-size-guide-shown-with-value]');
    this.baseCarat = this.dataset.defaultCarat || '3.0';
    this.shape = CARAT_SIZES_BY_SHAPE[this.dataset.shape] ? this.dataset.shape : 'round';

    this.pills.forEach((pill) => {
      pill.addEventListener('click', () => this.select(pill.dataset.carat));
    });

    this.select(this.baseCarat, false);
  }

  select(carat, animate = true) {
    const size = CARAT_SIZES_BY_SHAPE[this.shape][carat];
    const tabletSize = CARAT_SIZES_TABLET_BY_SHAPE[this.shape] && CARAT_SIZES_TABLET_BY_SHAPE[this.shape][carat];
    const mobileSize = CARAT_SIZES_MOBILE_BY_SHAPE[this.shape] && CARAT_SIZES_MOBILE_BY_SHAPE[this.shape][carat];
    if (!this.diamond || !size) return;

    this.diamond.style.transition = animate ? 'width 0.25s ease, height 0.25s ease' : 'none';
    this.diamond.style.setProperty('--diamond-size-guide-diamond-width', `${size.width.toFixed(2)}px`);
    this.diamond.style.setProperty('--diamond-size-guide-diamond-height', `${size.height.toFixed(2)}px`);
    if (tabletSize) {
      this.diamond.style.setProperty('--diamond-size-guide-diamond-tablet-width', `${tabletSize.width.toFixed(2)}px`);
      this.diamond.style.setProperty('--diamond-size-guide-diamond-tablet-height', `${tabletSize.height.toFixed(2)}px`);
    }
    if (mobileSize) {
      this.diamond.style.setProperty('--diamond-size-guide-diamond-mobile-width', `${mobileSize.width.toFixed(2)}px`);
      this.diamond.style.setProperty('--diamond-size-guide-diamond-mobile-height', `${mobileSize.height.toFixed(2)}px`);
    }

    if (this.shownWithValue) {
      this.shownWithValue.textContent = carat;
    }

    this.pills.forEach((pill) => {
      const isSelected = pill.dataset.carat === carat;
      pill.classList.toggle('is-selected', isSelected);
      pill.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });
  }
}

if (!customElements.get('diamond-size-guide')) {
  customElements.define('diamond-size-guide', DiamondSizeGuide);
}
